import SettingsPage from "../components/SettingsPane/SettingsPage";
import { CheckboxFieldSettings } from "../SettingsScreen";
import { itx } from "../translationItx/itx";

export default function SettingPageGPT(props: {
  handler: string;
  setRefresh?: (number: number) => void;
  refresh?: number;
}) {
  const { setRefresh, refresh } = props;
  return (
    <SettingsPage
      handler="/settings/gpt" // no itx
    >
      <CheckboxFieldSettings
        name="showResultWithJson" // no itx
        label={itx("SettingsScreen.showResultWithJson")}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </SettingsPage>
  );
}
